import { apiFetch, apiAction } from 'utils';

import DuckEntity from './DuckEntity'

import snippetSchema from '../schemas/snippet';
import taggableDuck from "./taggableDuck";

export default function Snippet(name, options = {}) {
  const entity = taggableDuck(new DuckEntity(name, Object.assign({
    schema: snippetSchema(name)
  }, options)));

  entity.actions.validate = (object) => apiAction(
    `schooladmin/${name}/VALIDATE_BEGIN`,
    `schooladmin/${name}/VALIDATE_SUCCESS`,
    `schooladmin/${name}/VALIDATE_ERROR`,
    (state) => apiFetch.post(
      state,
      `${entity.config.apiPath}/validate`,
      {[entity.config.jsonRoot]: object}
    )
  );

  return entity;
}
